import SyncService from '@/services/sync'


export default {
    namespaced: true,
    state: {

         config: JSON.stringify([]),
         configOk : false,
         rutaActual: JSON.stringify([]),
         parteRecogida : JSON.stringify([]),
         parteDescarga : JSON.stringify([]),
         parteOtraRecogida : JSON.stringify([]),
         parteTraspaso : JSON.stringify([]),
         partesExplotacion: JSON.stringify([]),

         // Tras enviar /api/recogidas el server devuelve recogida_id (cabecera).
         // Lo persistimos para encadenar /api/descargas y /api/traspasos a la
         // misma cabecera durante la jornada. Se limpia con RESET_ENVIO.
         recogidaCabeceraId: null,



    },

    getters: {

    
    
        getParteRecogida: state =>JSON.parse(state.parteRecogida),

        filterParteRecogida : (state) => {

          const rutaActual =JSON.parse(state.rutaActual)
          const parteRecogida =JSON.parse(state.parteRecogida)

          console.log('rutaActual', rutaActual,typeof(rutaActual),'parteRecogida',parteRecogida)

          return parteRecogida.find( item => item.Empresa.id === rutaActual.Empresa.id)
        },

        getConfig: state =>JSON.parse(state.config),
        getConfigOk: state =>JSON.parse(state.configOk),
        
        getRutaActual : state=>JSON.parse(state.rutaActual),
        filterConfigRutaActual : (state) => {

          const rutaActual =JSON.parse(state.rutaActual)
          if(rutaActual.length === 0){
            console.log('ruta',rutaActual)

            return
          }else{
            console.log('ruta else',rutaActual)

          }
          const config =JSON.parse(state.config)
          
          //if(config.length === 0) {

            const buscar =  config.find( item => item.Ruta.id === rutaActual.Ruta.id)

            console.log('filterConfigRutaActual 1209', buscar,
             rutaActual,typeof(rutaActual),config.length,typeof(config))
  
            return config.find( item => item.Ruta.id === rutaActual.Ruta.id)
            

         /*  }else{
            return rutaActual


          } */

       
        },
        getConfigId: (state) =>(id) =>  {
         return  JSON.parse(state.config.find( item => item.Ruta.id === id))
                           // const configItem2 = config.find(item=> item.Ruta.id === collect.Ruta.id)

        },

        search(state){
          return  id => JSON.parse(state.config.find( item => item.Ruta.id === id))
 
       

        }, 
          
         
         getConfigId2: state => id =>  {
          return  JSON.parse(state.config.find( item => item.Ruta.id === id))
                            // const configItem2 = config.find(item=> item.Ruta.id === collect.Ruta.id)
 
         },
        
        getTodoById: (state) => (id) => {
          console.log('1111111111',id)
          const rutaActual =JSON.parse(state.rutaActual)
          return rutaActual.find(item => item.Ruta.id === id)
        },

        getParteDescarga: state =>JSON.parse(state.parteDescarga),

        getPartesOtraRecogida: state =>JSON.parse(state.parteOtraRecogida),

        getPartesTraspaso: state => JSON.parse(state.parteTraspaso),

        getRecogidaCabeceraId: state => state.recogidaCabeceraId,

        /**
         * MAPA trazabilidad: nº total de items pendientes de subir en el dispositivo.
         * El guard del Config bloquea cambiar Vehiculo/Cisterna/Remolque/Conductor/Ruta
         * mientras pendingCount > 0.
         */
        pendingCount: state => {
          const safe = raw => { try { return JSON.parse(raw) || [] } catch { return [] } }
          return safe(state.parteRecogida).length
               + safe(state.parteOtraRecogida).length
               + safe(state.parteDescarga).length
               + safe(state.parteTraspaso).length
        },
 
        
        getPartesExplotacion : state => (explo)=>{

          const recogidas =JSON.parse(state.parteRecogida)
          console.log('124 -- getPartesExplotacion',recogidas, explo)
          return recogidas.filter((a) => {
    
             return a.Recogida.Explotacion.id === explo
          })
        },

        getPartesRecogidaExplotacion: state =>JSON.parse(state.parteDescarga),



      },
    
    mutations: {

      SET_PARTES_EXPLOTACION(state,partes){
        state.partesExplotacion = JSON.stringify(partes);

      },

        SET_CONFIG_OK(state,value){
          state.configOk = value;

        },
      
        SET_PARTE_DESCARGA(state,parte){
          state.parteDescarga =JSON.stringify(parte)

        },
        SET_PARTE_OTRA_RECOGIDA(state,parte){
          state.parteOtraRecogida = JSON.stringify(parte)
        },
        
        SET_PARTE_RECOGIDA(state,parte){
          state.parteRecogida = JSON.stringify(parte)
        },
        
        SET_CONFIG (state,config) {
            console.log('SET_CONFIG 1209',state,config)
            state.config = JSON.stringify(config)
            console.log('SET_CONFIG2222',state,config)

        },
        SET_RUTA_ACTUAL(state,ruta){
        console.log('SET_RUTA_ACTUAL',ruta)

          state.rutaActual = JSON.stringify(ruta)
          //{}
          //JSON.stringify(ruta)
          //console.log('SET_RUTA_ACTUAL',state.rutaActual,ruta)

        },

        SET_CONF(state, data) {
          console.log('SET_CONF',state,'data',data)
          for (const key in data) {
            if (Object.hasOwnProperty.call(state, key)) {
              state[key] = JSON.stringify(data[key])
             // console.log('sest__conf',state[key],data[key])
            }
          }
        
        },
        RESET_ENVIO(state) {
          state.parteRecogida = JSON.stringify([])
          state.parteOtraRecogida = JSON.stringify([])
          state.parteDescarga = JSON.stringify([])
          state.parteTraspaso = JSON.stringify([])
          state.recogidaCabeceraId = null
        },

        SET_PARTE_TRASPASO(state, parte) {
          state.parteTraspaso = JSON.stringify(parte)
        },

        SET_RECOGIDA_CABECERA_ID(state, id) {
          state.recogidaCabeceraId = id
        },
        RESET_SYNC(state,rootState,data) {
          console.log('RESET_SYNC',state,rootState,data);
          //rootState.sync.rutas = [];


        },

      
    },

    actions: {


      async setRutaActual({ commit, rootState, state }, ) {
        try {
          // traigo parte 
          const rutaActual = []

          commit('SET_RUTA_ACTUAL',  rutaActual )
          commit('SET_LOADING', true, { root: true })
          commit('SET_SUCCESS', true, { root: true })


          } catch (error) {
            console.log('error-DESCARGA',error)
            throw error
            console.log('error-recogida',error)
            //commit('SET_ERROR', error, { root: true })
          } finally {
            commit('SET_LOADING', false, { root: true })
          }
        




      },


      async upload({ commit, state, rootGetters }) {
        try {
          commit('SET_LOADING', true, { root: true })

          const recogidas = JSON.parse(state.parteRecogida)
          const descargas = JSON.parse(state.parteDescarga)
          const traspasos = JSON.parse(state.parteTraspaso)
          const otras = JSON.parse(state.parteOtraRecogida)
          const rutaActual = JSON.parse(state.rutaActual)

          // CentroRecogida se pierde al construir rutaActual (pantalla Config),
          // pero la ruta completa descargada (sync/rutas) SI lo trae. Lo
          // resolvemos para que la cabecera de recogida guarde el centro en vez
          // de null.
          const _rutaFull = (rootGetters['sync/rutas'] || []).find(r => r.Ruta?.id === rutaActual.Ruta?.id)
          const centrorecogidaId = rutaActual.CentroRecogida?.id || _rutaFull?.CentroRecogida?.id || null

          if (recogidas.length === 0 && otras.length === 0 && descargas.length === 0 && traspasos.length === 0) {
            throw new Error('No hay datos para enviar.')
          }

          // Regla MAPA (fuente unica, getter resumen/cuadre): solo se envia con la
          // jornada cerrada -> litros recogidos == descargados (y > 0). Antes este
          // test vivia solo en la UI de EnvioDatos y el guard de logout lo saltaba;
          // ahora se aplica a CUALQUIER camino de envio.
          const cuadre = rootGetters['resumen/cuadre']
          if (!cuadre.ok) {
            throw new Error(
              `No se puede enviar: los litros recogidos (${cuadre.cargados}) y descargados (${cuadre.descargados}) deben coincidir antes de enviar.`
            )
          }

          // Timestamp del envio (no solo la fecha del dia): asi el panel
          // refleja cuando se subio realmente y no 00:00.
          // Formato Y-m-d H:i:s nativo MySQL en lugar de ISO 8601 Z. El
          // backend (commit 2fdf445) ya normaliza ISO con Carbon, pero el
          // PWA no debe acumular deuda asumiendo que el server compensa.
          const pad = (n) => String(n).padStart(2, '0')
          const _now = new Date()
          const fechaDefault =
            `${_now.getFullYear()}-${pad(_now.getMonth() + 1)}-${pad(_now.getDate())}` +
            ` ${pad(_now.getHours())}:${pad(_now.getMinutes())}:${pad(_now.getSeconds())}`
          const result = { recogida_id: null, otras_ids: [], descargas_ids: [], traspasos_ids: [] }

          // ── 1) Recogidas a explotación: una sola petición con todas las líneas.
          // IDEMPOTENTE: si en un intento anterior ya se creó la cabecera (queda en
          // recogidaCabeceraId), NO se vuelve a crear al reintentar -> evita
          // cabeceras duplicadas cuando una descarga/otra falla y el conductor reenvía.
          if (recogidas.length > 0 && !state.recogidaCabeceraId) {
            // Albarán: la UI sólo lo captura en cabecera (rutaActual.Ruta.albaran).
            // El backend lo persiste por LÍNEA, no por cabecera (recogida_cabeceras
            // no tiene columna albaran → se descarta silenciosamente). Lo replicamos
            // en cada línea para que llegue donde se guarda.
            const albaranCab = rutaActual.Ruta?.albaran || null
            const lineas = recogidas.map(item => ({
              explotacion_codigo: item.Recogida.Explotacion.codigo,
              litros: item.Recogida.litros,
              temperatura: item.Recogida.temperatura,
              acidez: item.Recogida.acidez,
              inhibidores: item.Recogida.inhibidores,
              muestra: item.Recogida.muestra,
              tipo_leche: item.Recogida.tipoLeche,
              hora: item.Recogida.hora,
              // ── FKs y flags por línea: la UI ya los captura en el form de
              // Recogida explotación (ParteView.vue), pero el mapeo no los
              // pasaba al payload → backend dejaba todas estas columnas en NULL.
              tanque_id: item.Recogida.tanque ?? null,
              vehiculo_id: item.Recogida.vehiculo_id ?? null,
              cisterna_id: item.Recogida.cisterna_id ?? null,
              remolque_id: item.Recogida.remolque_id ?? null,
              cisternaRemolque: item.Recogida.cisternaRemolque ?? null,
              deposito: item.Recogida.deposito != null ? String(item.Recogida.deposito) : null,
              muestraSN: !!item.Recogida.muestraSN,
              contraMuestra: item.Recogida.contraMuestra ?? null,
              contraMuestraSN: !!item.Recogida.contraMuestraSN,
              recogida_motivo_rechazo_id: item.Recogida.motivo?.id || null,
              recogida_destino_rechazo_id: item.Recogida.destino?.id || null,
              albaran: albaranCab,
            }))
            const payload = {
              fecha: fechaDefault,
              nombre: rutaActual.Ruta?.nombre || null,
              // FKs de la cabecera para que el panel muestre Ruta/Vehiculo/
              // Cisterna/Remolque/CentroDestino. El server las acepta o ignora
              // segun la version del controller; mandar siempre es defensivo.
              ruta_id: rutaActual.Ruta?.id || null,
              vehiculo_id: rutaActual.Vehiculo?.id || null,
              cisterna_id: rutaActual.Cisterna?.id || null,
              remolque_id: rutaActual.Remolque?.id || null,
              // Conductor de la jornada = el del Config (rutaActual.Conductor), que
              // puede diferir del logueado. El server lo prefiere sobre el header.
              conductor_id: rutaActual.Conductor?.id || null,
              centrorecogida_id: centrorecogidaId,
              // albaran NO va en cabecera: la tabla recogida_cabeceras no tiene
              // esa columna. Va replicado en cada línea (ver lineas.map arriba).
              lineas,
            }
            // Logging del payload ANTES de enviar (cotejar contra
            // /admin/api-audits del server tras el POST).
            // - dev: aparece en console (terser dropea console.log en prod).
            // - prod: queda en window.__lastRecogidaPayload (inspeccionable en
            //   DevTools tecleando esa variable tras un envio).
            const _snap = JSON.parse(JSON.stringify(payload))
            if (typeof window !== 'undefined') window.__lastRecogidaPayload = _snap
            console.log('[upload] POST /api/recogidas payload:', _snap)
            const { data } = await SyncService.uploadRecogida(payload)
            result.recogida_id = data.recogida_id
            commit('SET_RECOGIDA_CABECERA_ID', data.recogida_id)
          }

          const cabeceraId = result.recogida_id || state.recogidaCabeceraId

          // ── 2) Descargas (vaciado): requieren recogida_cabecera_id.
          if (descargas.length > 0 && !cabeceraId) {
            throw new Error('Hay descargas pendientes pero no hay cabecera de recogida activa. Envía una recogida primero.')
          }
          for (const item of descargas) {
            const d = item.Descarga || item
            const payload = {
              recogida_cabecera_id: cabeceraId,
              // Conductor de la jornada (Config) — el server lo prefiere sobre el header.
              conductor_id: rutaActual.Conductor?.id || null,
              fecha: d.fecha || fechaDefault,
              hora: d.hora,
              vehiculo_id: d.vehiculo_id,
              cisterna_id: d.cisterna_id,
              remolque_id: d.remolque_id,
              cisternaRemolque: d.cisternaRemolque,
              deposito: d.deposito != null ? String(d.deposito) : null,
              vaciado: d.vaciado,
              tipoDestino: d.tipoDestino,
              centro_recogida_id: d.centro_recogida_id,
              letraq_destino: d.letraq_destino,
              lugar: d.lugar,
              matricula: d.matricula,
              conductor_destino_id: d.conductor_destino_id,
              codigo_pais_conductor: d.codigo_pais_conductor,
              codigo_nif_conductor: d.codigo_nif_conductor,
              nombre_conductor: d.nombre_conductor,
              litros: d.litros,
              peso: d.peso,
              tara: d.tara,
              tipo_leche: d.tipoLeche || d.tipo_leche,
              temperatura: d.temperatura,
              acidez: d.acidez,
              inhibidores: d.inhibidores,
              albaran: d.albaran,
              muestra: d.muestra,
              muestraSN: d.muestraSN,
              recogida_motivo_rechazo_id: d.recogida_motivo_rechazo_id,
              recogida_destino_rechazo_id: d.recogida_destino_rechazo_id,
              letraq_rechazo: d.letraq_rechazo,
            }
            if (typeof window !== 'undefined') window.__lastDescargaPayload = JSON.parse(JSON.stringify(payload))
            const { data } = await SyncService.uploadDescarga(payload)
            result.descargas_ids.push(data.id)
          }

          // ── 3) Traspasos entre depósitos: requieren cabecera_id.
          if (traspasos.length > 0 && !cabeceraId) {
            throw new Error('Hay traspasos pendientes pero no hay cabecera de recogida activa.')
          }
          for (const item of traspasos) {
            const t = item.Traspaso || item
            const payload = {
              recogida_cabecera_id: cabeceraId,
              vehiculo_id: t.vehiculo_id,
              fecha: t.fecha || fechaDefault,
              hora: t.hora,
              deposito_origen: t.deposito_origen != null ? String(t.deposito_origen) : null,
              deposito_destino: t.deposito_destino != null ? String(t.deposito_destino) : null,
              litros: t.litros,
              tipo_leche: t.tipo_leche || t.tipoLeche,
              observaciones: t.observaciones,
            }
            const { data } = await SyncService.uploadTraspaso(payload)
            result.traspasos_ids.push(data.id)
          }

          // ── 4) Otras recogidas: independientes de la cabecera, una por petición.
          for (const item of otras) {
            const o = item.OtraRecogida
            // Nombres CANONICOS (= columna BD del server). El controller ya no
            // depende del remapeo: lo que se manda es lo que se guarda
            // (CONTRATO-DATOS §5). Los denormalizados van al final solo para el
            // audit (el server los descarta).
            const payload = {
              // Vincular la otra a la cabecera de la jornada. Sin esto se guarda
              // con recogida_cabecera_id=null y el export (que agrupa por cabecera)
              // NO la incluye. El server ya acepta y guarda este campo.
              recogida_cabecera_id: cabeceraId,
              fecha: o.fecha || fechaDefault,
              hora: o.hora,
              albaran: o.albaran,
              // Conductor de la jornada = el del Config (rutaActual.Conductor), que
              // puede diferir del logueado. El server lo prefiere sobre el header.
              conductor_id: rutaActual.Conductor?.id || o.conductor_id || null,
              vehiculo_id: o.vehiculo_id || null,
              // ── Origen.
              origen: o.origen,
              simogan_origen: o.simoganOrigen,
              // FKs: 0 / "" / falsy -> null (los sentinels "Nueva" del combobox usan id=0).
              letraq_id_origen: o.letraqOrigenId || null,
              deposito_origen: o.letraqOrigenDeposito != null ? String(o.letraqOrigenDeposito) : null,
              vaciado: o.letraqOrigenVaciado,
              industria_id: o.operadorId || null,
              // El conductor origen se elige de la lista de NIFs (no de conductors),
              // asi que su id (999 centinela o un nifs.id) NO es un conductors.id.
              // Enviar null; el origen viaja por pais/NIF/nombre (denormalizados).
              conductor_id_origen: (o.conductorIdOrigen && o.conductorIdOrigen !== 999) ? o.conductorIdOrigen : null,
              centrorecogida_id: o.centroRecogidaId || null,
              // ── Destino en mi camion.
              cisternaRemolque: o.cisternaRemolque,
              deposito_destino: o.deposito != null ? String(o.deposito) : null,
              cisterna_destino_id: o.cisternaRemolque === 'Cisterna' ? (o.cisterna_id || null) : null,
              remolque_destino_id: o.cisternaRemolque === 'Remolque' ? (o.remolque_id || null) : null,
              // ── Datos / calidad.
              tipo_leche: o.tipoLeche,
              litros: o.litros,
              temperatura: o.temperatura,
              acidez: o.acidez,
              inhibidores: o.inhibidores,
              muestra: o.muestra,
              muestraSN: !!o.muestraSN,
              leche_certificada: o.lecheCertificada || null,
              observaciones: o.observaciones || null,
              recogida_motivo_rechazo_id: o.motivo?.id || null,
              recogida_destino_rechazo_id: o.destino?.id || null,
              // ── Denormalizados (sin columna; preservados en api_audits).
              letraq_origen: o.letraqOrigen,
              letraq_origen_matricula: o.letraqOrigenMatricula,
              operador_codigo: o.operadorCodigo,
              operador_dni: o.operadorDni,
              operador_nombre: o.operadorNombre,
              conductor_origen_nombre: o.conductorNombreOrigen,
              conductor_origen_dni: o.conductorDniOrigen,
              conductor_origen_pais: o.conductorPaisOrigen,
              centro_recogida_codigo: o.centroRecogidaCodigo,
              centro_recogida_nombre: o.centroRecogidaNombre,
              centro_recogida_localidad: o.centroRecogidaLocalidad,
              matricula: o.matricula,
              conductor_nombre: o.conductorNombre,
              conductor_dni: o.conductorDni,
            }
            // Inspeccionable en prod (DevTools) para cotejar con /admin/api-audits.
            if (typeof window !== 'undefined') window.__lastOtraRecogidaPayload = JSON.parse(JSON.stringify(payload))
            const { data } = await SyncService.uploadOtraRecogida(payload)
            result.otras_ids.push(data.id)
          }

          commit('RESET_ENVIO')
          return result
        } catch (error) {
          if (!error.response) {
            throw new Error(error.message)
          }
          const serverError = error.response.data.error || error.response.data.message || 'Error desconocido en el envío'
          throw new Error(serverError)
        } finally {
          commit('SET_LOADING', false, { root: true })
        }
      },

      async deletePartesRealizados({ commit, rootState, state }) {
        try {
          // traigo parte 
          console.log('0410 deletePartesRealizados STATE : ',rootState);
          //const parteGuardado = JSON.parse(state.parteRecogida) 

          const parteRecogida =[];// JSON.parse(state.parteRecogida)
          const parteOtraRecogida = [];//JSON.parse(state.parteOtraRecogida)
          const parteDescargas = [];//;JSON.parse(state.parteDescarga)
          const rutaActual = [];
          const config = [];
          
           commit('SET_PARTE_RECOGIDA',  parteRecogida )
          commit('SET_PARTE_OTRA_RECOGIDA',  parteOtraRecogida )
          commit('SET_PARTE_DESCARGA',  parteDescargas )
          // Resetear el id de cabecera: sin esto, el guard de idempotencia del
          // upload saltaria las recogidas de la proxima jornada (id apuntando a una
          // cabecera ya inexistente) y fallarian las descargas.
          commit('SET_RECOGIDA_CABECERA_ID', null)
         commit('SET_RUTA_ACTUAL',  rutaActual )
         commit('SET_CONFIG',  config )
 
     /*   commit('RESET_SYNC',rootState)  
          commit('sync/SET_ERROR', null) */

                  
          commit('SET_LOADING', true, { root: true })            
          commit('SET_SUCCESS', true, { root: true })

          console.log('0410 deletePartesRealizados STATE : ',state);





        } catch (error) {
          console.log('error-recogida',error)
          throw error
        } finally {
          console.log('0410 deletePartesRealizados FINALY');

          commit('SET_LOADING', false, { root: true })
        }
      }, 
          

      async deleteSoloPartesRealizados({ commit, rootState, state }) {
        try {
          // traigo parte 
     

          //const parteGuardado = JSON.parse(state.parteRecogida) 

          const parteRecogida =[];// JSON.parse(state.parteRecogida)
          const parteOtraRecogida = [];//JSON.parse(state.parteOtraRecogida)
          const parteDescargas = [];//;JSON.parse(state.parteDescarga)
          const rutaActual = [];
          const config = [];
              
          
        commit('SET_PARTE_RECOGIDA',  parteRecogida )
          commit('SET_PARTE_OTRA_RECOGIDA',  parteOtraRecogida )
          commit('SET_PARTE_DESCARGA',  parteDescargas )
          commit('SET_RECOGIDA_CABECERA_ID', null) // reset id cabecera (ver deletePartesRealizados)
          commit('SET_CONFIG',  config )
       // commit('SET_RUTA_ACTUAL',  rutaActual )
 
     /*   commit('RESET_SYNC',rootState)  
          commit('sync/SET_ERROR', null) */

                  
          commit('SET_LOADING', true, { root: true })            
          commit('SET_SUCCESS', true, { root: true })

          console.log('0410 deletePartesRealizados STATE : ',state);





        } catch (error) {
          console.log('error-recogida',error)
          throw error
        } finally {
          console.log('0410 deletePartesRealizados FINALY');

          commit('SET_LOADING', false, { root: true })
        }
      }, 
          


      async deleteParteRecogida({ commit, rootState, state }, parteEnviado) {
        try {
          // traigo parte 
          const parteGuardado = JSON.parse(state.parteRecogida)


          console.log('inicializo ',parteGuardado,typeof(parteGuardado),
          'parteEnviado', parteEnviado,
          )


          
        /*   const parteItem = parteGuardado.filter(item=> 
            item.Recogida.Explotacion.id !== parteEnviado.Recogida.Explotacion.id
            ) || [] */
            
            const parteItem = parteGuardado.filter(item=> 
              item.Recogida.uuid !== parteEnviado.Recogida.uuid            
            ) || []

          

          
          //parteItem.push(parteEnviado)

          commit('SET_PARTE_RECOGIDA',  parteItem )
          console.log('assigno parte guardado',parteItem,
          'parteGuardado',parteGuardado
          )

            commit('SET_LOADING', true, { root: true })
                        
            commit('SET_SUCCESS', true, { root: true })

          } catch (error) {
            console.log('error-recogida',error)
            throw error
            console.log('error-recogida',error)
            //commit('SET_ERROR', error, { root: true })
          } finally {
            commit('SET_LOADING', false, { root: true })
          }
      
      },

      async setParteRecogida({ commit, rootState, state }, parteEnviado) {
        try {
          if (!parteEnviado.Recogida.uuid) {
            parteEnviado.Recogida.uuid = crypto.randomUUID();
          }

          const partesRecogidaGuardados = JSON.parse(state.parteRecogida)

          const parteItem = partesRecogidaGuardados.filter(item=>
              item.Recogida.uuid !== parteEnviado.Recogida.uuid
            ) || []

          parteItem.push(parteEnviado)

          commit('SET_PARTE_RECOGIDA',  parteItem )
          commit('SET_LOADING', true, { root: true })
          commit('SET_SUCCESS', true, { root: true })


          } catch (error) {
            console.log('error-recogida',error)
            throw error
            console.log('error-recogida',error)
            commit('SET_ERROR', error, { root: true })
          } finally {
            console.log('0410 setParteRecogida FINALY');
            commit('SET_LOADING', false, { root: true })
          }
        
      },

      async setParteOtraRecogida({ commit, rootState, state }, parteEnviado) {
        try {
          // traigo parte 
          const parteGuardado = JSON.parse(state.parteOtraRecogida)


          console.log('OtraRecogidasssss 25',parteGuardado,typeof(parteGuardado),
          'parteEnviado', parteEnviado,
          'parteGuardado', parteGuardado.OtraRecogida,
          'parteEnviado', parteEnviado.OtraRecogida,

          
          )

          

          const parteItem = parteGuardado.filter(item=> item.OtraRecogida.id !== parteEnviado.OtraRecogida.id) 

          // si estoy no hago nada
          console.log('inicializo 22222 ',parteGuardado,typeof(parteGuardado),
          'parteItem',parteItem,
          

          )
          parteItem.push(parteEnviado)

          commit('SET_PARTE_OTRA_RECOGIDA',  parteItem )
          console.log('assigno parte guardado',parteItem,
          'parteGuardado',parteGuardado
          )


            
              

            commit('SET_LOADING', true, { root: true })
            

            
            commit('SET_SUCCESS', true, { root: true })


          } catch (error) {
            console.log('error-recogida',error)
            throw error
            console.log('error-recogida',error)
            //commit('SET_ERROR', error, { root: true })
          } finally {
            commit('SET_LOADING', false, { root: true })
          }
        




      },

      async deleteParteOtraRecogida({ commit, rootState, state }, parteEnviado) {
        try {
          // traigo parte 
          const parteGuardado = JSON.parse(state.parteOtraRecogida) 
          console.log('2407 parteEnviado',parteEnviado,
          'parteGuardado',parteGuardado);
          
          //.descarga,parteEnviado.otraRecogida.Descarga.id)

          console.log('2407 parteGuardado',parteGuardado)

          const parteItem = parteGuardado.filter(item=> item.OtraRecogida.id !== parteEnviado.OtraRecogida.OtraRecogida.id) || []

          console.log('2407 parteItem',parteItem)

          commit('SET_PARTE_OTRA_RECOGIDA',  parteItem )
          commit('SET_LOADING', true, { root: true })
          commit('SET_SUCCESS', true, { root: true })


          } catch (error) {
            console.log('error-DESCARGA',error)
            throw error
            console.log('error-recogida',error)
            //commit('SET_ERROR', error, { root: true })
          } finally {
            commit('SET_LOADING', false, { root: true })
          }
        
      },

      async setParteDescarga({ commit, rootState, state }, parteEnviado) {
        try {
          // traigo parte 
          const parteGuardado = JSON.parse(state.parteDescarga)
          let parteItem
          console.log('inicializo ',parteGuardado,'-item',parteEnviado)

          if(parteEnviado.Descarga.id){
               parteItem = parteGuardado.filter(item=> item.Descarga.id !== parteEnviado.Descarga.id) 
          }else{
              parteItem = parteGuardado
          }

          console.log('inicializo 222222',parteGuardado,'-item',parteItem)

          
          parteItem.push(parteEnviado)

          commit('SET_PARTE_DESCARGA',  parteItem )
          console.log('inicializo assigno parte guardado',
          'parteGuardado',parteGuardado,
          'parteItem', parteItem,
          )
  
          commit('SET_LOADING', true, { root: true })
                        
          commit('SET_SUCCESS', true, { root: true })


          } catch (error) {
            console.log('error-recogida',error)
            throw error
            console.log('error-recogida',error)
            //commit('SET_ERROR', error, { root: true })
          } finally {
            commit('SET_LOADING', false, { root: true })
          }
        




      },

      async deleteParteDescarga({ commit, rootState, state }, parteEnviado) {
        try {
          // traigo parte 
          const parteGuardado = JSON.parse(state.parteDescarga) 
          console.log('2407 parteEnviado',parteEnviado,parteEnviado.descarga,parteEnviado.descarga.Descarga.id)

          console.log('2407 parteGuardado',parteGuardado)

          const parteItem = parteGuardado.filter(item=> item.Descarga.id !== parteEnviado.descarga.Descarga.id) || []

          console.log('2407 parteItem',parteItem)


          commit('SET_PARTE_DESCARGA',  parteItem )
          commit('SET_LOADING', true, { root: true })
          commit('SET_SUCCESS', true, { root: true })


          } catch (error) {
            console.log('error-DESCARGA',error)
            throw error
            console.log('error-recogida',error)
            //commit('SET_ERROR', error, { root: true })
          } finally {
            commit('SET_LOADING', false, { root: true })
          }
        




      },
     
      async updateConfig({ commit, rootState, state }, ruta) {
        // recibo form ... modificado..
        // filter de config sin form .. 
        // push config and SETCONFIG...

        try {
          // traigo config 
          const config = JSON.parse(state.config)
          console.log('inicializo UPDATE',config,typeof(config),
          'ruta', ruta)
          const configItem = config.filter(item=> item.Ruta.id !== ruta.Ruta.id) || []
          
          // si estoy no hago nada
          console.log('inicializo UPDATE222222',config,typeof(config),
          'ruta',ruta,
          'configItem',configItem,
          

          )

              configItem.push(ruta)

              commit('SET_CONFIG',  configItem )
              commit('SET_RUTA_ACTUAL',  ruta )

              console.log('set_config assigno UPDATE',config,configItem,
              'ruta',ruta
              )
              
          
        } catch (error) {
          console.log('error-recogida',error)
          throw error
          console.log('error-recogida',error)
          //commit('SET_ERROR', error, { root: true })
        } finally {
           commit('SET_LOADING', false, { root: true })
        }

      },
        
      
      async setConfig({ commit, rootState, state }, ruta) {
        try {

          console.log('setConfig',ruta);
            // busco una ruta bajada de este conductor 
            if (ruta.length==0){

             // commit('SET_CONFIG',  [] ) // INICALIZO 
             //quitado , deberia inicializar solo si cambia de usuario ???? 
            }else{

              const config = JSON.parse(state.config) 
              //commit('SET_CONFIG',  [] ) // INICALIZO  
              const configItem = config.find(item=> item.Ruta.id === ruta.Ruta.id) || []

              if (configItem.length === 0 ){
                config.push(ruta)
                commit('SET_CONFIG',  config )

              } 
              
              commit('SET_RUTA_ACTUAL',  ruta )
          
              commit('SET_LOADING', true, { root: true })
                
              commit('SET_SUCCESS', true, { root: true })


            }

          } catch (error) {
            console.log('error-recogida',error)
            throw error
            console.log('error-recogida',error)
            //commit('SET_ERROR', error, { root: true })
          } finally {
            commit('SET_LOADING', false, { root: true })
          }
        




      },




    }


}